import Inicio from "../views/Inicio.vue";
import Login from "../views/Login.vue";
import Inscripcion from "../views/Inscripcion.vue";
import Actualizar from "../views/Actualizar.vue";
import View404 from "../views/404.vue";
import store from "../store";
const updateRoutes = () => {
  return new Promise((resolve, reject) => {
    store
      .dispatch("fetchEstrategias")
      .then(() => {
        const data = [
          {
            path: "/",
            name: "inicio",
            component: Inicio,
            beforeEnter: checkGuards,
            meta: {
              middlewareGuest: true,
              middlewareAuth: false
            }
          },
          {
            path: `/:estrategia${store.getters.getSlugRegex}`,
            name: "login",
            component: Login,
            beforeEnter: checkGuards,
            meta: {
              middlewareGuest: true,
              middlewareAuth: false
            }
          },
          {
            path: `/:estrategia${store.getters.getSlugRegex}/inscripcion`,
            name: "inscripcion",
            component: Inscripcion,
            beforeEnter: checkGuards,
            meta: {
              middlewareGuest: false,
              middlewareAuth: true
            }
          },
          {
            path: `/:estrategia${store.getters.getSlugRegex}/actualizar`,
            name: "actualizar",
            component: Actualizar,
            beforeEnter: checkGuards,
            meta: {
              middlewareGuest: false,
              middlewareAuth: true
            }
          },
          {
            path: "*",
            name: "notfound",
            component: View404
          }
        ];
        resolve(data);
      })
      .catch(err => {
        reject(err);
      });
  });
};

let checkGuards = (to, from, next) => {
  // Si la ruta requiere auth y no esta autenticado
  if (
    to.matched.some(record => record.meta.middlewareAuth) &&
    !store.getters.valida
  ) {
    next({
      name: "login",
      params: to.params,
      replace: true
    });
    return;
  }

  // Si la ruta es Guest y esta autenticado
  if (
    to.matched.some(record => record.meta.middlewareGuest) &&
    store.getters.valida
  ) {
    let route = store.getters.debeActualizar ? "actualizar" : "inscripcion";
    next({
      name: route,
      params: { estrategia: store.getters.estrategia },
      replace: true
    });
    return;
  }

  // Si la ruta es Auth y esta autenticado pero el parametro es diferente a la estrategia
  if (checkInvalidParams(to)) {
    let route = store.getters.debeActualizar ? "actualizar" : "inscripcion";
    next({
      name: route,
      params: { estrategia: store.getters.estrategia },
      replace: true
    });
    return;
  }

  store.commit("setEstrategia", to.params.estrategia);
  next();
};

let checkInvalidParams = to => {
  let name = store.getters.debeActualizar ? "actualizar" : "inscripcion";
  let routeAuth = to.matched.some(record => record.meta.middlewareAuth);
  let auth = store.getters.valida;
  let invalidParam = to.params.estrategia != store.getters.estrategia;
  let invalidPath = to.name != name;

  return routeAuth && auth && (invalidParam || invalidPath);
};

export default updateRoutes;
